import { createFileRoute } from "@tanstack/react-router";
import { TemplatesPage } from "@/features/workflows/TemplatesPage";

export const Route = createFileRoute("/_app/automations/templates")({
  component: () => <TemplatesPage />,
});
